/**
 * @props inputName form input name
 * @props data the data voor the object must
 */

import React from "react";

import { Add } from "@mui/icons-material";
import { FormLabel, Tooltip } from "@mui/material";

import TimeSlot from "./TimeSlot";
import Button from "../CustomButtons/Button";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";

import { withStyles } from "tss-react/mui";
import TimeTableStyle from "./TimeTableStyle";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

class TimeTable extends React.Component {
  state = {
    data: this.props.data ?? {},
    loaded: false,
    emptySlots: {
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
      7: false,
    },
  };

  days = [
    { label: "maandag", key: "mo" },
    { label: "dinsdag", key: "tu" },
    { label: "woensdag", key: "we" },
    { label: "donderdag", key: "th" },
    { label: "vrijdag", key: "fr" },
    { label: "zaterdag", key: "sa" },
    { label: "zondag", key: "su" },
  ];

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: this.props.data,
      });
    }
  }

  /**
   * Refreshen van keys anders is de rendering soms niet helemaal goed
   */
  refreshKey = Math.ceil(Math.random() * 100);

  regenerateRefreshKey = () => {
    this.refreshKey = Math.ceil(Math.random() * 100);
  };

  /**
   * Converten van data van json string naar object
   */
  convertData = () => {
    const dataType = typeof this.state.data;

    /**
     * Als string is en niet empty dan JSON parse
     */
    if (dataType === "string") {
      if (this.state.data !== "") {
        return JSON.parse(this.state.data);
      }
    }

    /**
     * Als het al object is dan niks mee doen
     */
    if (dataType === "object" && this.state.data !== null) {
      return this.state.data;
    }

    return {};
  };

  handleTimeSettingsChange = (arrPlace, action, data = null) => {
    let arrPlaces = arrPlace.split(",");

    let newSettings = { ...this.convertData() };

    /**
     * ADD NIEUW TIMESLOT
     */
    if (action === "ADD") {
      if (newSettings[arrPlaces[0]] === undefined) {
        newSettings[arrPlaces[0]] = [];
      }

      newSettings[arrPlaces[0]].push(data);
    }

    /**
     * UPDATE A TIMESLOT
     */
    if (action === "UPDATE") {
      newSettings[arrPlaces[0]][arrPlaces[1]] = data;
    }

    /**
     * DELETE A TIME SLOT
     */
    if (action === "DELETE") {
      newSettings[arrPlaces[0]].splice(arrPlaces[1], 1);
      if (newSettings[arrPlaces[0]].length === 0) {
        delete newSettings[arrPlaces[0]];
      }
    }

    this.setState({ data: newSettings });
    if (this.props.onChange) {
      this.props.onChange(newSettings);
    }
  };

  toggleEmptySlots = (rowKey) => {
    let newEmptySlots = { ...this.state.emptySlots };
    newEmptySlots[rowKey] = !newEmptySlots[rowKey];

    this.setState({
      emptySlots: newEmptySlots,
    });
  };

  getSubmitData = () => {
    if (Object.keys(this.convertData()).length === 0) {
      return undefined;
    }

    return JSON.stringify(this.convertData());
  };

  /**
   * Render
   */
  render() {
    const { classes } = this.props;
    const data = this.convertData();

    return (
      <div key={"timeTable" + this.refreshKey}>
        <input name={this.props.inputName} type={"hidden"} value={this.getSubmitData() ? this.getSubmitData() : ""} />

        {this.days.map((day, key) => {
          return (
            <GridContainer key={key}>
              <GridItem lg={2} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={day.label} tKey={"datetime" + "." + "dagen." + day.label} />
                </FormLabel>
              </GridItem>

              {data[day.key] !== undefined
                ? data[day.key].map((tijdSlot, key) => {
                    return (
                      <TimeSlot
                        arrPlace={day.key + "," + key}
                        forceRefresh={this.regenerateRefreshKey}
                        handleTimeSettings={this.handleTimeSettingsChange}
                        key={key + this.refreshKey}
                        maxItems={tijdSlot["maxItems"] !== undefined ? tijdSlot["maxItems"] : 0}
                        showMaxItems={this.props.showMaxItems}
                        startTimeOrg={tijdSlot["startTime"]}
                        stopTimeOrg={tijdSlot["stopTime"]}
                        toggleEmptySlots={() => this.toggleEmptySlots(day.key)}
                      />
                    );
                  })
                : null}

              <GridItem>
                {this.state.emptySlots[day.key] ? (
                  <TimeSlot
                    arrPlace={day.key + ",9999"}
                    editing
                    handleTimeSettings={this.handleTimeSettingsChange}
                    isNewSlot
                    key={day.key + "empty" + this.refreshKey}
                    showMaxItems={this.props.showMaxItems}
                    startTimeOrg={"00:00"}
                    stopTimeOrg={"00:00"}
                    toggleEmptySlots={() => this.toggleEmptySlots(day.key)}
                  />
                ) : (
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement={"bottom"}
                    title={<TranslationWrapper tDefault={"Toevoegen"} tKey={"global.tooltip.toevoegen"} />}
                  >
                    <Button
                      className={classes.actionButton}
                      color={"success"}
                      onClick={() => this.toggleEmptySlots(day.key)}
                      simple
                    >
                      <Add className={classes.icon} />
                    </Button>
                  </Tooltip>
                )}
              </GridItem>
            </GridContainer>
          );
        })}
      </div>
    );
  }
}

export default withStyles(TimeTable, TimeTableStyle);
